import React, { useEffect, useState, useRef } from "react";
import "./HospitalityV2OrderPage.scss"
import MenuFooter from "../../../components/Footer/MenuFooter/MenuFooter";
import MenuNavbarMini from "../../../components/Navbar/MenuNavbarMini";
import arrow from "../../../assets/arrow-black.svg";
import lock from "../../../assets/lock.svg";
import info from "../../../assets/info-2.svg";
import secu from "../../../assets/secure.svg";
import profile from "../../../assets/profile-2.svg";
import deliveryIc from "../../../assets/delivery-cycle.svg"
import collectionIC from "../../../assets/shop.svg"
import dineinIC from "../../../assets/fork.svg"
import covers from "../../../assets/covers.svg"
import seatings from "../../../assets/seating.svg"
import clock from "../../../assets/clock-five.svg"
import card from "../../../assets/card-line.svg"
import cash from "../../../assets/dollar.svg"
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import IMAGE_PLACEHOLDER from "../../../assets/images/Images/empty-placeholder.png"
import { LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from "../../../../RestaurantWidget/utilities/helper/helper";
import DataValidation, { DATA_VALIDATION_TYPES } from "../../../../RestaurantWidget/utilities/helper/dataValidation";
import CustomCheckbox from "../../../components/CustomCheckbox/CustomCheckbox";
import CustomInput from "../../../components/CustomInput/CustomInput";
import CustomPhoneInput from "../../../components/CustomInput/CustomPhoneInput";
import CustomTextArea from "../../../components/CustomInput/CustomTextArea";
import { getRestaurantMenuSettingsData } from "../../../../../../utilities/apiRequests/neutriPosServerRequests";
import { sendPaymentDetails } from "../../../../RestaurantWidget/utilities/api/paymentService";
import { checklocation, getFloorDetails, placeOrder, predictPrice, updateOrderTypeDetails } from "../../../../RestaurantWidget/utilities/api/restaurantsService";
import { setOrderData, setOrderDataPayment, setOrderEmpty, setSelectedOrderType } from "../../../../../../../../redux/resturantWidgetSlice";
import HospitalityV2Payment from "./HospitalityV2Payment";
import Modal from "../../../components/Modal/Modal";
// import CustomRadioButton from "../../../components/CustomRadioButton/CustomRadioButton";
import HospitalityLoginModal from "../Auth/HospitalityLoginModal/HospitalityLoginModal";
import moment from "moment";
import { getPreparationSettings } from "../../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { setPreparationSettings } from "../../../../../../../../redux/companyDataSlice";
import { getOrderTypeData } from "../../../../../../utilities/restaurantMenuUtil";
import { getCurrencyFormat, getLocalStorageData } from "../../../../../../utilities/helper";
import LocationFinder from "../../../components/OrderPicker/LocationFinder/LocationFinder";
import ScheduleOrderModal from "../ScheduleOrderModal/ScheduleOrderModal";
import ModalOpt from "../../../components/Modal/ModalOpt";

const HospitalityV2OrderPage = () => {
    const adyenRef = useRef(null);
    const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);

    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const userDetails = localStorage.getItem('fullUserDetails')
    let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
    const userDetailsDelivery = localStorage.getItem('DELIVERY_DATA')
    let parsedUserDetailsDelivery = JSON.parse(localStorage.getItem('DELIVERY_DATA'))
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;
    const address = userDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Billing") : null
    const phoneNumberAddress = userDetails ? parsedUserDetails?.Addresses[0]?.Phone || "" : ""
    const addressDelivery = selectedOrderType === "delivery" ? userDetailsDelivery ? parsedUserDetailsDelivery.Addresses.find((address) => address.AddressType === "Delivery") : null : userDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Delivery") : null
    let useDeliveryForBilling = companyDetails?.settings?.OnlineOrder?.Delivery?.UseDeliveryForBilling && selectedOrderType === "delivery"
    const orderID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : ""
    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null
    const getNationalNumber = (phone) => {
        if (!phone) return '';
        try {
            const parsed = parsePhoneNumberFromString(phone);
            return parsed ? parsed.nationalNumber : phone;
        } catch (error) {
            return phone;
        }
    };
    const customerDetailsInitialState = {
        firstName: {
            value: userDetails ? parsedUserDetails.FirstName : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
        },
        lastName: {
            value: userDetails ? parsedUserDetails.LastName : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
        },
        mobileNo: {
            value: phoneNumberAddress ? "+44" + phoneNumberAddress ?? "" : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_PHONE_NO],
        },
        emailAddress: {
            value: userDetails ? parsedUserDetails.Email : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_EMAIL],
        },
        customerAddress: {
            line1: {
                value: useDeliveryForBilling ? addressDelivery?.AddressLine1 || "" : address ? address.AddressLine1 : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: defaultDetails && defaultDetails.selectedOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            line2: {
                value: useDeliveryForBilling ? addressDelivery?.AddressLine2 || "" : address ? address.AddressLine2 : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            state: {
                value: useDeliveryForBilling ? addressDelivery?.StateProvinceRegion || "" : address ? address.StateProvinceRegion : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: defaultDetails && defaultDetails.selectedOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            city: {
                value: useDeliveryForBilling ? addressDelivery?.City || "" : address ? address.City : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: defaultDetails && defaultDetails.selectedOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            postcode: {
                value: useDeliveryForBilling ? addressDelivery?.PostZipCode || "" : address ? address.PostZipCode : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: defaultDetails && defaultDetails.selectedOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_POSTCODE],
            },
            country: {
                value: 'United Kingdom',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
        },
        deliveryAddress: {
            line1: {
                value: addressDelivery?.AddressLine1 || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            line2: {
                value: addressDelivery?.AddressLine2 || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            state: {
                value: addressDelivery?.StateProvinceRegion || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            city: {
                value: addressDelivery?.City || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            postcode: {
                value: addressDelivery?.PostZipCode || '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            country: {
                value: 'United Kingdom',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            instruction: {
                value: '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
        },
        isDeliveryAddressSame: useDeliveryForBilling ? true : false,
        instruction: {
            value: "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [],
        },
    };
    let amountTypes = [{
        label: "No, I'll have the exact amount",
        needChange: false
    },
    {
        label: "Yes, I need change",
        needChange: true
    }]
    const dispatch = useDispatch()
    let history = useHistory();
    const search = history.location.search;
    const params = new URLSearchParams(search);
    const redirectResult = params.get('redirectResult');
    const [checkoutFailed, setCheckoutFailed] = useState("");
    const [customerDetails, setCustomerDetails] = useState(customerDetailsInitialState);
    const [isCollapsed, setIsCollapsed] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [showPaymentErrorModal, setShowPaymentErrorModal] = useState(false)
    const [promo, setPromo] = useState("")
    const [isGuest, setIsGuest] = useState(localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? false : true)
    const [isCardPayment, setIsCardPayment] = useState(true)
    const [isOrderLoading, setIsOrderLoading] = useState(false)
    const [paymentTypes, setPaymentTypes] = useState([])
    const [isPaymentLoading, setIsPaymentLoading] = useState(false)
    const [isSameOrderType, setIsSameOrderType] = useState(selectedOrderType)
    const [isValidating, setIsValidating] = useState(false)
    const [deliverySuccess, setDeliverySuccess] = useState(false);
    const [deliveryFailed, setDeliveryFailed] = useState(false);
    const [deliveryNotverfied, setDeliveryNotverfied] = useState(false);
    const [rulesChecked, setRulesChecked] = useState(false);
    const [promoChecked, setPromoChecked] = useState(false);
    const [selectedFloor, setSelectedFloor] = useState(null)
    const [selectedTable, setSelectedTable] = useState(null)
    // const [needChange, setNeedChange] = useState(false);
    // const [changeAmount, setChangeAmount] = useState("")
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [schedModal, setSchedModal] = useState(false);
    const [isError, setIsError] = useState(false)
    const enableSchdeulOrders = companyDetails?.settings?.EnableScheduledOrder || false
    const [addDeliveryLoc, setAddDeliveryLoc] = useState(false);
    const [interval, setInterval] = useState(30);
    const [showAll, setShowAll] = useState(false);
    const [isScheduleTimeError, setIsScheduleTimeError] = useState(false);
    const [isStoreClosed, setIsStoreClosed] = useState(false);
    const [emailChecked, setEmailChecked] = useState(false)
    const [smsChecked, setSmsChecked] = useState(false)
    const [whatsappChecked, setWhatsappChecked] = useState(false)
    const [showPopup, setShowPopup] = useState(false)

    const currencyFormat = getCurrencyFormat(restaurantDataState.currency);

    const getNext7Days = () => {
        const days = [];
        const today = new Date();

        for (let i = 0; i < 7; i++) {
            const nextDate = new Date(today);
            nextDate.setDate(today.getDate() + i);
            days.push(nextDate.toISOString().split('T')[0]);
        }

        return days;
    };
    const [isStoreOrderBlocked, setIsStoreOrderBlocked] = useState(false);
    const [scheduleOrder, setScheduleOrder] = useState(enableSchdeulOrders && localStorage.getItem("schedule_order") ? localStorage.getItem("schedule_order") : JSON.stringify({}));
    const preparationSettings = useSelector((state) => state.companyData.preparationSettings);
    const getFullfillmentType = () => {
        let type
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER"
                break;
            case "collection":
                type = "TAKE_AWAY"
                break;
            case "table":
                type = "DINE_IN"
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER"
                break;
        }
        return type
    }
    useEffect(() => {
        const fetchData = async () => {
            let locationID = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
            getPreparationSettings(locationID).then((response) => {
                dispatch(setPreparationSettings(response))
                const time = response?.Durations?.find(
                    (duration) =>
                        duration.OrderType === getFullfillmentType() &&
                        duration.Schedule === 'STANDARD'
                );
                if (time) {
                    setInterval(time.DurationInMin)
                    if (!enableSchdeulOrders) {
                        let timeSched = JSON.stringify({})
                        setScheduleOrder(timeSched)
                    }
                }
            })
        }
        fetchData()
    }, [])
    const isOverlapping = (start1, end1, start2, end2) => {
        return start1.isBefore(end2) && end1.isAfter(start2);
    };
    const [selectedDate, setSelectedDate] = useState(localStorage.getItem("schedule_order") ? JSON.parse(localStorage.getItem("schedule_order")).StartTime?.split('T')[0] : getNext7Days()[0])
    const getTodayIntervals = () => {
        const now = moment();
        const date = moment(selectedDate);
        const isToday = date.isSame(now, 'day');
        const currentDay = date.format('dddd');
        const blockedTimes = companyDetails?.settings?.OnlineOrder?.BlockedHours
        const orderSettings =
            selectedOrderType === "delivery"
                ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Delivery
                : selectedOrderType === "collection"
                    ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Takeaway
                    : companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.DineIn;

        const todaySchedule = orderSettings?.find(d => d.Day === currentDay);
        if (!todaySchedule || todaySchedule.Closed) return [];

        const intervals = [];

        todaySchedule.OpenHours.forEach(({ StartTime, EndTime }) => {
            let start = moment(StartTime, 'HH:mm').set({
                year: date.year(),
                month: date.month(),
                date: date.date(),
            });
            let end = moment(EndTime, 'HH:mm').set({
                year: date.year(),
                month: date.month(),
                date: date.date(),
            });

            if (end.isBefore(start)) {
                end.add(1, 'day');
            }

            const endOfDay = moment(date).endOf('day').set({ second: 59 });

            if (end.isAfter(endOfDay)) {
                end = endOfDay;
            }
            const time = preparationSettings?.Durations?.find(
                (duration) =>
                    duration.OrderType === getFullfillmentType() &&
                    duration.Schedule === 'STANDARD'
            );
            const intervalVal = time?.DurationInMin || interval
            while (start.isBefore(end)) {
                const next = moment(start).add(intervalVal, 'minutes');
                if (next.isAfter(end)) break;

                if (isToday && start.isSameOrBefore(now)) {
                    start = next;
                    continue;
                }

                intervals.push({
                    StartTime: start.clone(),
                    EndTime: next.clone(),
                });

                start = next;
            }
        });

        const todayBlocked = blockedTimes.find(b => b.Day === currentDay)?.Time || [];
        const filteredIntervals = intervals.filter(({ StartTime, EndTime }) => {
            const intervalStart = moment(StartTime);
            const intervalEnd = moment(EndTime);
            return !todayBlocked.some(({ StartTime: bStart, EndTime: bEnd }) => {
                const blockedStart = moment(bStart, 'HH:mm').set({
                    year: date.year(),
                    month: date.month(),
                    date: date.date(),
                });
                const blockedEnd = moment(bEnd, 'HH:mm').set({
                    year: date.year(),
                    month: date.month(),
                    date: date.date(),
                });
                return isOverlapping(intervalStart, intervalEnd, blockedStart, blockedEnd);
            });
        });
        const timeIntervals = filteredIntervals.map(({ StartTime, EndTime }) => ({
            StartTime: StartTime.format('HH:mm'),
            EndTime: EndTime.format('HH:mm'),
        }))
        return showAll ? timeIntervals : timeIntervals.slice(0, 5);
    };
    const [selectedTime, setSelectedTime] = useState(getTodayIntervals()[0])

    useEffect(() => {
        let schedTime = localStorage.getItem("schedule_order")
        if (schedTime) {
            let timeSched = JSON.parse(localStorage.getItem("schedule_order"))
            let dateP = timeSched?.StartTime?.split('T');
            setSelectedDate(dateP[0])
            setScheduleOrder(JSON.stringify(timeSched))

        } else {
            if (getTodayIntervals().length > 0) {
                setSelectedTime(getTodayIntervals()[0])
                setScheduleOrder(JSON.stringify({}))
            }

        }
    }, [])
    useEffect(() => {
        let schedTime = localStorage.getItem("schedule_order")
        if (schedTime) {
            let timeSched = JSON.parse(localStorage.getItem("schedule_order"))
            let [datePart, timePartWithMsStart] = timeSched?.StartTime?.split('T');
            let [datePartEnd, timePartWithMsEnd] = timeSched?.EndTime?.split('T');
            const timePartStart = timePartWithMsStart?.slice(0, 5);
            const timePartEnd = timePartWithMsEnd?.slice(0, 5);
            let isInfirstFive = getTodayIntervals()?.find((val) => val.StartTime === timePartStart)

            if (datePart === selectedDate) {
                setSelectedTime({
                    StartTime: timePartStart,
                    EndTime: timePartEnd
                })
                setScheduleOrder(JSON.stringify(timeSched))
                if (!isInfirstFive) {
                    setShowAll(true)
                }

            } else {
                if (enableSchdeulOrders) {
                    setSelectedTime(getTodayIntervals()[0])
                    let scheduletime = {
                        StartTime: `${selectedDate}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                        EndTime: `${selectedDate}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
                    }
                    setScheduleOrder(JSON.stringify(scheduletime))
                    localStorage.setItem("schedule_order", JSON.stringify(scheduletime))
                }
            }
        } else {
            if (getTodayIntervals().length > 0) {
                setSelectedTime(getTodayIntervals()[0])
                setScheduleOrder(JSON.stringify({}))
            }
        }
    }, [selectedDate])
    useEffect(() => {
        if (preparationSettings) {
            const time = preparationSettings?.Durations?.find(
                (duration) =>
                    duration.OrderType === getFullfillmentType() &&
                    duration.Schedule === 'STANDARD'
            );
            if (time) {
                setInterval(time.DurationInMin)
                let schedTime = localStorage.getItem("schedule_order")
                if (schedTime) {
                    let timeSched = JSON.parse(localStorage.getItem("schedule_order"))
                    let [datePart, timePartWithMsStart] = timeSched?.StartTime?.split('T');
                    let [datePartEnd, timePartWithMsEnd] = timeSched?.EndTime?.split('T');
                    const timePartStart = timePartWithMsStart?.slice(0, 5);
                    const timePartEnd = timePartWithMsEnd?.slice(0, 5);
                    let isInfirstFive = getTodayIntervals()?.find((val) => val.StartTime === timePartStart)
                    if (datePart === selectedDate) {
                        setSelectedTime({
                            StartTime: timePartStart,
                            EndTime: timePartEnd
                        })
                        if (!isInfirstFive) {
                            setShowAll(true)
                        }
                    } else {
                        if (enableSchdeulOrders) {
                            setSelectedTime(getTodayIntervals()[0])
                            let scheduletime = {
                                StartTime: `${selectedDate}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                                EndTime: `${selectedDate}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
                            }
                            setScheduleOrder(JSON.stringify(scheduletime))
                            localStorage.setItem("schedule_order", JSON.stringify(scheduletime))
                        }
                    }

                } else {
                    if (getTodayIntervals().length > 0) {
                        setSelectedTime(getTodayIntervals()[0])
                        setScheduleOrder(JSON.stringify({}))
                    }
                }
            }
        }
    }, [preparationSettings, selectedDate])

    const getPaymenttypes = async () => {
        const paymentSettings = await getRestaurantMenuSettingsData({
            SettingType: "PaymentMethods",
            CloudLocationID: storeOrderLocalData.cloudLocationID,
        })
        const paymentMethods = paymentSettings.map((type) => type.PaymentMethod);
        setPaymentTypes(paymentMethods);
        return paymentMethods;

    }
    const handlePaymentMethods = async () => {
        let types = await getPaymenttypes()
        if (types.length === 1 && types[0] === "card") {
            setIsCardPayment(true)
        } else {
            setIsCardPayment(userDetails ? parsedUserDetails.DefaultPaymentType === "Card" ? true : false : false)
        }
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        if (orderID === "" && customerDetails) {
            history.push("/")
        } else {
            handlePaymentMethods()

        }
    }, [])
    useEffect(() => {
        if (redirectResult) {
            sendPaymentDetailsRedirect()
            setIsCardPayment(true)
        }
    }, [])
    useEffect(() => {
        if (defaultDetails && defaultDetails.selectedOrderType === "table" && restaurantDataState.orderDetails.FulfillmentType === "DINE_IN") {
            getFloorDetails().then((response) => {
                if (response) {
                    let value = response.map((floor) =>
                        floor.Tables.map((table) => {
                            if (table.LocalID === defaultDetails.tableLocalId) {

                                let floorDataValue = {
                                    Id: floor.ID,
                                    Name: floor.ItemName.Translations.en,
                                    LocalReference: { Id: floor.LocalID }
                                }
                                let data = {
                                    TableID: table.ID,
                                    TableName: table.TableName,
                                    LocalReference: { Id: table.LocalID },
                                    Floor: floorDataValue,
                                    Covers: table.Covers
                                }
                                setSelectedFloor(floorDataValue)
                                setSelectedTable(data)
                                localStorage.setItem("selected_table", JSON.stringify(data))
                                return data;
                            }
                            return null;
                        })
                    )
                        .flat()
                        .filter(Boolean)[0];
                    let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: value }
                    dispatch(setOrderData(updatedData))
                }
            })
        }
    }, [])
    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (restaurantDataState.orderDetails.FulfillmentType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const extractTitles = (group) => {
        return group.SelectedItems.flatMap((item) => {
            const title = item.Title.replace(/\.+$/, '').toLowerCase();
            const nestedTitles =
                item.SelectedModifierGroups?.length > 0
                    ? item.SelectedModifierGroups.flatMap(extractTitles)
                    : [];
            return [title, ...nestedTitles];
        });
    };

    const renderModifierGroups = (selectedGroup) => {
        const titles = extractTitles(selectedGroup);
        return <span>{titles.join(', ')}</span>;
    };
    const onFormDataChanged = (property, value) => {
        setCustomerDetails((prevState) => {
            const [key, subKey] = property.split('.');

            if (subKey) {
                return {
                    ...prevState,
                    [key]: {
                        ...prevState[key],
                        [subKey]: {
                            ...prevState[key][subKey],
                            value,
                            errorMessage: "",
                            hasError: false

                        },
                    },
                };
            }

            return {
                ...prevState,
                [property]: {
                    ...prevState[property],
                    value,
                    errorMessage: "",
                    hasError: false


                },
            };
        });
    };
    const getErrorMessage = (type) => {
        let message = ""
        switch (type) {
            case 'REQUIRED_FIELD':
                message = "This field is required."
                break;
            case 'IS_EMAIL':
                message = "Please enter a valid email address."
                break;
            case 'IS_TEXT_ONLY':
                message = "Input must contain letters only"
                break;
            case 'IS_POSTCODE':
                message = "Please enter a valid Postcode."
                break;
            case 'IS_PHONE_NO':
                message = "Please enter a valid Phonenumber."
                break;
            case 'IS_PHONE_NO_VALID':
                message = "Please enter a valid Phone number."
                break;
            default:
                break;
        }
        return message
    }
    const validateFieldSet = (fields) => {
        let pageHasError = false;
        const newFields = { ...fields };
        for (const key in fields) {
            if (!fields.hasOwnProperty(key)) continue;

            let validationRes = { hasError: false, errorType: null };

            for (const validation of fields[key].validations) {
                if (validationRes.hasError) break;

                validationRes = DataValidation(validation, fields[key].value, fields[key].additional ?? null);
                fields[key].errorMessage = getErrorMessage(validationRes.errorType)
            }

            if (validationRes.hasError) pageHasError = true;

            newFields[key] = {
                ...newFields[key],
                ...validationRes,
            };
        }

        return {
            fields: newFields,
            hasError: pageHasError,
        };
    };

    const validateAllFormData = () => {
        return new Promise(async (resolve) => {
            const userId = localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

            const {
                customerAddress,
                deliveryAddress,
                isDeliveryAddressSame,
                ...basicFields
            } = customerDetails;

            const newBasic = validateFieldSet(basicFields);
            const newCustomerAddress = validateFieldSet(customerAddress);
            const newDeliveryAddress = isDeliveryAddressSame
                ? { fields: customerAddress, hasError: false }
                : validateFieldSet(deliveryAddress);

            const pageHasError = newBasic.hasError || newCustomerAddress.hasError || newDeliveryAddress.hasError;

            setCustomerDetails((prevState) => ({
                ...prevState,
                ...newBasic.fields,
                customerAddress: newCustomerAddress.fields,
                deliveryAddress: newDeliveryAddress.fields,
            }));

            if (!pageHasError) {
                const customerFormData = {
                    ID: userId,
                    Name: {
                        DisplayName: basicFields.firstName.value.trim(),
                        FirstName: basicFields.firstName.value.trim(),
                        LastName: basicFields.lastName.value.trim(),
                    },
                    Email: basicFields.emailAddress.value.trim(),
                    Contact: {
                        Number: getNationalNumber(basicFields.mobileNo.value.replace("+44", "")),
                        PinCode: "+44",
                        CountryISO2: "GB",
                    },
                    BillingAddress: {
                        Id: "",
                        AddressType: "",
                        AddressLine1: useDeliveryForBilling ? deliveryAddress.line1?.value || "" : customerAddress.line1.value,
                        AddressLine2: useDeliveryForBilling ? deliveryAddress.line2?.value || "" : customerAddress.line2?.value || "",
                        StateProvinceRegion: useDeliveryForBilling ? deliveryAddress.state?.value || "" : customerAddress.state.value,
                        PostZipCode: useDeliveryForBilling ? deliveryAddress.postcode?.value || "" : customerAddress.postcode.value,
                        Country: useDeliveryForBilling ? deliveryAddress.country?.value || "" : customerAddress.country.value,
                        City: useDeliveryForBilling ? deliveryAddress.city?.value || "" : customerAddress.city.value,
                        CountryCode: "",
                        AddressLabel: "",
                        Longitude: 0,
                        Latitude: 0,
                        Additional: {
                            Instruction: "",
                            InteractionType: "",
                        },
                    },
                    DeliveryAddress: {
                        Id: "",
                        AddressType: "",
                        AddressLine1: isDeliveryAddressSame ? customerAddress.line1.value : deliveryAddress.line1?.value,
                        AddressLine2: isDeliveryAddressSame ? customerAddress.line2?.value || "" : deliveryAddress.line2?.value || "",
                        StateProvinceRegion: isDeliveryAddressSame ? customerAddress.state.value : deliveryAddress.state?.value,
                        PostZipCode: isDeliveryAddressSame ? customerAddress.postcode.value : deliveryAddress.postcode?.value,
                        Country: isDeliveryAddressSame ? customerAddress.country.value : deliveryAddress.country?.value,
                        City: isDeliveryAddressSame ? customerAddress.city.value : deliveryAddress.city?.value,
                        CountryCode: "",
                        AddressLabel: "",
                        Longitude: 0,
                        Latitude: 0,
                        Additional: {
                            Instruction: deliveryAddress?.instruction?.value || "",
                            InteractionType: "",
                        },
                    },
                };

                const data = {
                    UserID: userId,
                    CompanyName: "",
                    UserName: basicFields.firstName.value.toLowerCase().trim(),
                    FirstName: basicFields.firstName.value.trim(),
                    LastName: basicFields.lastName.value.trim(),
                    Email: basicFields.emailAddress.value.trim(),
                    Addresses: [
                        {
                            AddressType: "Billing",
                            HouseNo: "",
                            AddressLine1: useDeliveryForBilling ? deliveryAddress.line1?.value || "" : customerAddress.line1.value,
                            AddressLine2: useDeliveryForBilling ? deliveryAddress.line2?.value || "" : customerAddress.line2?.value || "",
                            City: useDeliveryForBilling ? deliveryAddress.city?.value || "" : customerAddress.city.value || "",
                            StateProvinceRegion: useDeliveryForBilling ? deliveryAddress.state?.value || "" : customerAddress.state.value,
                            PostZipCode: useDeliveryForBilling ? deliveryAddress.postcode?.value || "" : customerAddress.postcode.value,
                            Country: useDeliveryForBilling ? deliveryAddress.country?.value || "" : customerAddress.country.value,
                            Phone: getNationalNumber(basicFields.mobileNo.value.replace("+44", "")),
                            Fax: "",
                            Email: basicFields.emailAddress.value.trim(),
                            CreatedDate: "",
                            LastModifiedDate: "",
                            IsDefault: false,
                            IsActive: false,
                            TelephoneCode: "+44",
                            AddressLabel: "",
                        },
                        {
                            AddressType: "Delivery",
                            HouseNo: "",
                            AddressLine1: isDeliveryAddressSame ? customerAddress.line1.value : deliveryAddress.line1?.value,
                            AddressLine2: isDeliveryAddressSame ? customerAddress.line2?.value || "" : deliveryAddress.line2?.value || "",
                            City: isDeliveryAddressSame ? customerAddress.city?.value || "" : deliveryAddress.city?.value || "",
                            StateProvinceRegion: isDeliveryAddressSame ? customerAddress.state.value : deliveryAddress.state?.value,
                            PostZipCode: isDeliveryAddressSame ? customerAddress.postcode.value : deliveryAddress.postcode?.value,
                            Country: isDeliveryAddressSame ? customerAddress.country.value : deliveryAddress.country?.value,
                            Phone: getNationalNumber(basicFields.mobileNo.value.replace("+44", "")),
                            Fax: "",
                            Email: basicFields.emailAddress.value.trim(),
                            CreatedDate: "",
                            LastModifiedDate: "",
                            IsDefault: false,
                            IsActive: false,
                            TelephoneCode: "+44",
                            AddressLabel: "",
                        },
                    ],
                };
                localStorage.setItem("fullUserDetails", JSON.stringify(data));
                await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS, customerFormData);
            }

            resolve(pageHasError);
        });
    };
    const getCustomerDetails = () => {
        const userId = localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
        const {
            customerAddress,
            deliveryAddress,
            isDeliveryAddressSame,
            ...basicFields
        } = customerDetails;
        const customerFormData = {
            ID: userId,
            Name: {
                DisplayName: basicFields.firstName.value.trim(),
                FirstName: basicFields.firstName.value.trim(),
                LastName: basicFields.lastName.value.trim(),
            },
            Email: basicFields.emailAddress.value.trim(),
            Contact: {
                Number: getNationalNumber(basicFields.mobileNo.value.replace("+44", "")),
                PinCode: "+44",
                CountryISO2: "GB",
            },
            BillingAddress: {
                Id: "",
                AddressType: "",
                AddressLine1: useDeliveryForBilling ? deliveryAddress.line1?.value || "" : customerAddress.line1.value,
                AddressLine2: useDeliveryForBilling ? deliveryAddress.line2?.value || "" : customerAddress.line2?.value || "",
                StateProvinceRegion: useDeliveryForBilling ? deliveryAddress.state?.value || "" : customerAddress.state.value,
                PostZipCode: useDeliveryForBilling ? deliveryAddress.postcode?.value || "" : customerAddress.postcode.value,
                Country: useDeliveryForBilling ? deliveryAddress.country?.value || "" : customerAddress.country.value,
                City: useDeliveryForBilling ? deliveryAddress.city?.value || "" : customerAddress.city.value,
                CountryCode: "",
                AddressLabel: "",
                Longitude: 0,
                Latitude: 0,
                Additional: {
                    Instruction: "",
                    InteractionType: "",
                },
            },
            DeliveryAddress: {
                Id: "",
                AddressType: "",
                AddressLine1: isDeliveryAddressSame ? customerAddress.line1.value : deliveryAddress.line1?.value,
                AddressLine2: isDeliveryAddressSame ? customerAddress.line2?.value || "" : deliveryAddress.line2?.value || "",
                StateProvinceRegion: isDeliveryAddressSame ? customerAddress.state.value : deliveryAddress.state?.value,
                PostZipCode: isDeliveryAddressSame ? customerAddress.postcode.value : deliveryAddress.postcode?.value,
                Country: isDeliveryAddressSame ? customerAddress.country.value : deliveryAddress.country?.value,
                City: isDeliveryAddressSame ? customerAddress.city.value : deliveryAddress.city?.value,
                CountryCode: "",
                AddressLabel: "",
                Longitude: 0,
                Latitude: 0,
                Additional: {
                    Instruction: deliveryAddress?.instruction?.value || "",
                    InteractionType: "",
                },
            },
        };
        return customerFormData
    }

    const sendPaymentDetailsRedirect = () => {
        const paymentDetailsRequest = {
            cloudLocationID: storeOrderLocalData.cloudLocationID,
            reference: `Online-${storeOrderLocalData.cloudLocationID}-Ecom-${orderID}`,
            siteTransactionRef: orderID,
            store: `Ecommerce_${storeOrderLocalData.cloudLocationID}`,
            countryCode: "GB",
            paymentDetailInput: {
                redirectResult: redirectResult

            },
            shopperReference: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),

        }
        setIsPaymentLoading(true)
        sendPaymentDetails(paymentDetailsRequest, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
            if (response) {
                if (response.resultCode && response.resultCode === "Authorised") {
                    const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
                    history.push(`/order/success/${oid}`)
                    dispatch(setOrderEmpty())
                    setIsOrderLoading(false)
                    setIsPaymentLoading(false)
                    dispatch(setSelectedOrderType(""))
                    localStorage.removeItem("selected_table")
                    localStorage.removeItem("schedule_order")
                    sessionStorage.removeItem("store_instruction")
                } else {
                    history.push(`/order/failed`)
                }
            } else {
                history.push(`/order/failed`)
            }
        })

    }
    const placeCartOrder = (type) => {
        if (restaurantDataState.orderCartData.Items.length > 0) {
            const table = localStorage.getItem("selected_table") ? JSON.parse(localStorage.getItem("selected_table")) : {}
            const schedTime = JSON.parse(scheduleOrder)
            setIsOrderLoading(true)
            setIsPaymentLoading(true)
            const customer = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}
            if (customer) {
                let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customer }]
                let updatedData = {
                    ...restaurantDataState.orderDetails, Customers: customerData, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType,
                    DineIn: table, OrderType
                        : "MENU", PaymentType: type,
                    StoreInstructions: sessionStorage.getItem("store_instruction") ?? "",
                    ScheduledOrderTargetDeliveryTimeRange: schedTime.StartTime ? { StartTime: schedTime?.StartTime, EndTime: schedTime?.EndTime } : {},
                    OptForPromotions: promoChecked,
                    PromotionOptions: {
                        WhatsApp: whatsappChecked,
                        Email: emailChecked,
                        SMS: smsChecked
                    }
                }
                placeOrder(updatedData).then((response) => {
                    if (response) {
                        const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
                        history.push(`/order/success/${oid}`)
                        dispatch(setOrderEmpty())
                        setIsOrderLoading(false)
                        setIsPaymentLoading(false)
                        dispatch(setSelectedOrderType(""))
                        localStorage.removeItem("selected_table")
                        localStorage.removeItem("schedule_order")
                        sessionStorage.removeItem("store_instruction")
                    }
                }).catch((error) => {
                    setIsOrderLoading(false)
                    history.push(`/order/failed`)
                })
            } else {
                setIsOrderLoading(false)
                history.push(`/order/failed`)
            }

        }
    }
    const getErrorFields = (state) => {
        const errorFields = [];

        for (const key in state) {
            const field = state[key];
            if (field && field.hasError) {
                errorFields.push(key);
            }

            if (typeof field === 'object') {
                for (const subKey in field) {
                    const subField = field[subKey];
                    if (subField && subField.hasError) {
                        errorFields.push(`${key}.${subKey}`);
                    }
                }
            }
        }

        return errorFields;
    }
    const formatFieldNames = (fields) => {
        return fields.map(field => {
            return field
                .split('.')
                .map(part => part.charAt(0).toUpperCase() + part.slice(1).replace(/([A-Z])/g, ' $1'))
                .join(' ');
        });
    }
    const getErrorMessages = () => {
        let fields = getErrorFields(customerDetails)
        let formattedFileds = formatFieldNames(fields)
        let message = ""
        if (formattedFileds.length > 2) {
            message = "There are multiple fields missing. Please fill in all the required fields to continue."
        } else {
            message = `${formattedFileds.join(", ")}  ${formattedFileds.length === 1 ? "is" : "are"} missing. Please fill in all the required fields to continue.`
        }
        return message
    }

    const updateOrderType = (type) => {
        return new Promise((resolve) => {
            let body = {
                "OrderID": orderID,
                "DeliveryType": type,
                "CountryCode": "GB"
            }
            updateOrderTypeDetails(body).then((res) => {
                dispatch(setOrderData(res))
                resolve(res)
            })
        })
    }
    const handleUpdateOrder = async () => {
        const orderTypes = [
            { type: "collection", typeValue: "TAKE_AWAY" },
            { type: "delivery", typeValue: "DELIVERY_BY_REWARDCONSUMER" },
            { type: "table", typeValue: "DINE_IN" },
        ];

        const matchedType = orderTypes.find((val) => val.type === selectedOrderType);

        if (matchedType && restaurantDataState.orderDetails.FulfillmentType !== matchedType.typeValue) {
            dispatch(setSelectedOrderType(matchedType.type))
            await updateOrderType(matchedType.typeValue);
        }
    };
    const getTotal = (data, newData) => {
        let responsePrice = data?.Gross?.AmountE5
        let totalPrice = newData?.Payment?.
            PaymentDetail?.OrderTotal?.Gross?.AmountE5 + responsePrice
        return {
            AmountE5: totalPrice,
            Formatted: `£${(totalPrice / 100).toFixed(2)}`,
            CurrencyCode: "GBP"
        }
    }
    const hanldeConfirm = (data) => {
        setIsValidating(true)
        let req = {
            "CloudLocationID": storeOrderLocalData?.cloudLocationID,
            "Store": {
                "AddressLine1": companyDetails.address.line1,
                "AddressLine2": companyDetails.address.line2,
                "City": companyDetails.address.city,
                "StateProvinceRegion": companyDetails.address.state,
                "PostZipCode": companyDetails.address.postcode,
                "Country": companyDetails.address.country,
                "CountryCode": "GB",
            },
            "Customer": {
                "AddressLine1": customerDetails.deliveryAddress.line1.value,
                "AddressLine2": customerDetails.deliveryAddress.line2.value,
                "City": customerDetails.deliveryAddress.city.value,
                "StateProvinceRegion": customerDetails.deliveryAddress.state.value,
                "PostZipCode": customerDetails.deliveryAddress.postcode.value,
                "Country": customerDetails.deliveryAddress.country.value,
                "CountryCode": "GB",
            }
        }
        let emptydeliveryAddress = {
            line1: {
                value: "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            line2: {
                value: "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            state: {
                value: "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            city: {
                value: "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            postcode: {
                value: "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            country: {
                value: 'United Kingdom',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
        }

        checklocation(req).then((response) => {
            if (response) {
                if (response !== "") {
                    localStorage.setItem("DELIVERY_DATA", JSON.stringify(data))
                    updateOrderType("DELIVERY_BY_REWARDCONSUMER").then((resolveData) => {
                        if (resolveData) {
                            let pricedata = {
                                "CloudLocationID": storeOrderLocalData?.cloudLocationID,
                                "OrderID": orderID,
                                "ReferenceNo": response
                            }
                            predictPrice(pricedata).then((res) => {
                                localStorage.setItem("DELIVERY_DATA", JSON.stringify(data))
                                localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                dispatch(setSelectedOrderType("delivery"))
                                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID, response)
                                let dataRes =
                                {
                                    Details: res.Details,
                                    Total: getTotal(res.Total, resolveData)
                                }

                                dispatch(setOrderDataPayment(dataRes))
                                setIsValidating(false)
                                setDeliveryFailed(false)
                                setDeliverySuccess(true)

                            }).catch((error) => {
                                console.log(error)
                                if (error.response.status === 404) {
                                    setIsValidating(false)
                                    localStorage.setItem("DELIVERY_DATA", JSON.stringify(data))
                                    localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                    dispatch(setSelectedOrderType("delivery"))
                                    localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID, response)
                                    setCheckoutFailed(error.response.data.Result)
                                }
                            })
                        }
                    })
                } else {
                    localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
                    setIsValidating(false)
                    setDeliverySuccess(false)
                    setDeliveryFailed(true)
                }
            } else {
                localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
                setIsValidating(false)
                setDeliverySuccess(false)
                setDeliveryFailed(true)
                setCustomerDetails({ ...customerDetails, deliveryAddress: emptydeliveryAddress })
            }

        }).catch((e) => {
            localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
            setIsValidating(false)
            setDeliverySuccess(false)
            setDeliveryFailed(true)
            setCustomerDetails({ ...customerDetails, deliveryAddress: emptydeliveryAddress })
        })
    }
    const getScheduleContent = () => {
        const title = selectedOrderType === "delivery" ? "Delivery" : "Collection"

        return (
            <>
                <div className="left-content-container-border">{title} Date</div>
                <div className="delivery-date-container">
                    {getNext7Days().map((day, key) => {
                        const selected = selectedDate === day
                        const date = moment(day);
                        const today = moment();
                        const isToday = date.isSame(today, 'day');
                        const isTomorrow = date.isSame(today.clone().add(1, 'day'), 'day');
                        return (
                            <div className={`delivery-date-container-item ${selected ? "selected" : ""}`} key={key}
                                onClick={() => {
                                    setSelectedDate(day)
                                }}>
                                <div className="fle">{isToday
                                    ? 'Today'
                                    : isTomorrow
                                        ? 'Tomorrow'
                                        : date.format('dddd')}, {date.format('MMM DD')}</div>

                            </div>
                        )
                    })}
                </div>
                <div className="left-content-container-border">{title} Time</div>
                <div className="delivery-time-container">
                    {getTodayIntervals().map((time, key) => {
                        const selected = JSON.stringify(selectedTime) === JSON.stringify(time)
                        return (
                            <div className={`delivery-time-container-item ${selected ? "selected" : ""}`} key={key}
                                onClick={() => {
                                    if (enableSchdeulOrders) {
                                        setSelectedTime(time)
                                        let scheduletime = {
                                            StartTime: `${selectedDate}T${time.StartTime}:00.000Z`,
                                            EndTime: `${selectedDate}T${time.EndTime}:00.000Z`,
                                        }
                                        setScheduleOrder(JSON.stringify(scheduletime))
                                        localStorage.setItem("schedule_order", JSON.stringify(scheduletime))
                                    }
                                }}
                            >
                                <div className="fle">
                                    <img alt="" src={clock} className="icon-item" />{moment(time?.StartTime, "HH:mm").format('hh:mm A')} - {moment(time?.EndTime, "HH:mm").format('hh:mm A')}
                                </div>
                            </div>

                        )
                    })}
                    {!showAll ? <div className="show-all-text"
                        onClick={() => {
                            setShowAll(true)
                        }}>Show All</div> : <div className="show-all-text"
                            onClick={() => {
                                setShowAll(false)
                            }}>Hide</div>}
                </div>
            </>
        )

    }
    const getDeliveryContent = () => {
        return (
            <>
                <div className="left-content-container-header">Delivery Address</div>
                <div className="left-content-container-flex">
                    <CustomInput
                        required
                        label={"Address Line 1"}
                        icon={"address"}
                        placeholder="Enter your address"
                        value={customerDetails.deliveryAddress.line1.value}
                        error={customerDetails.deliveryAddress.line1.hasError}
                        onChange={(e) => onFormDataChanged('deliveryAddress.line1', e.target.value)}
                        errorText={customerDetails.deliveryAddress.line1.errorMessage}
                        disable={useDeliveryForBilling}
                    />
                    <CustomInput
                        label={"Address Line 2"}
                        placeholder="Apt, suite, or other (optional)"
                        value={customerDetails.deliveryAddress.line2.value}
                        error={customerDetails.deliveryAddress.line2.hasError}
                        onChange={(e) => onFormDataChanged('deliveryAddress.line2', e.target.value)}
                        errorText={customerDetails.deliveryAddress.line2.errorMessage}
                        disable={useDeliveryForBilling}

                    />
                </div>
                <div className="left-content-container-flex">
                    <CustomInput
                        required
                        label={"City"}
                        placeholder="City"
                        value={customerDetails.deliveryAddress.city.value}
                        error={customerDetails.deliveryAddress.city.hasError}
                        onChange={(e) => onFormDataChanged('deliveryAddress.city', e.target.value)}
                        errorText={customerDetails.deliveryAddress.city.errorMessage}
                        disable={useDeliveryForBilling}
                    />
                    <CustomInput
                        required
                        label={"Postal Code"}
                        placeholder="Postal Code"
                        value={customerDetails.deliveryAddress.postcode.value}
                        error={customerDetails.deliveryAddress.postcode.hasError}
                        onChange={(e) => onFormDataChanged('deliveryAddress.postcode', e.target.value)}
                        errorText={customerDetails.deliveryAddress.postcode.errorMessage}
                        disable={useDeliveryForBilling}
                    />
                    <CustomInput
                        required
                        label={"State"}
                        placeholder="State"
                        value={customerDetails.deliveryAddress.state.value}
                        error={customerDetails.deliveryAddress.state.hasError}
                        onChange={(e) => onFormDataChanged('deliveryAddress.state', e.target.value)}
                        errorText={customerDetails.deliveryAddress.state.errorMessage}
                        disable={useDeliveryForBilling}
                    />
                    <CustomInput
                        label={"Country"}
                        placeholder="Country"
                        value={customerDetails.deliveryAddress.country.value}
                        disable
                    />
                </div>
                <div className="left-content-container-flex">
                    <CustomTextArea
                        label={"Delivery Instructions (Optional)"}
                        placeholder="Add any special instructions for delivery (e.g., doorbell doesn't work, call upon arrival)"
                        value={customerDetails?.deliveryAddress?.instruction?.value}
                        error={customerDetails?.deliveryAddress?.instruction?.hasError}
                        onChange={(e) => onFormDataChanged('deliveryAddress.instruction', e.target.value)}
                        errorText={customerDetails?.deliveryAddress?.instruction?.errorMessage}
                    />
                </div>
                {selectedOrderType !== "delivery" && <div className="validate-btn"


                    onClick={() => {
                        if (!isValidating) {
                            let customerValue = {
                                deliveryAddress: {
                                    line1: {
                                        value: customerDetails.deliveryAddress.line1.value || "",
                                        hasError: false,
                                        errorType: null,
                                        errorMessage: null,
                                        validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                                    },
                                    line2: {
                                        value: customerDetails.deliveryAddress.line2.value || "",
                                        hasError: false,
                                        errorType: null,
                                        errorMessage: null,
                                        validations: [],
                                    },
                                    state: {
                                        value: customerDetails.deliveryAddress.state.value || "",
                                        hasError: false,
                                        errorType: null,
                                        errorMessage: null,
                                        validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                                    },
                                    city: {
                                        value: customerDetails.deliveryAddress.city.value || "",
                                        hasError: false,
                                        errorType: null,
                                        errorMessage: null,
                                        validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                                    },
                                    postcode: {
                                        value: customerDetails.deliveryAddress.postcode.value || "",
                                        hasError: false,
                                        errorType: null,
                                        errorMessage: null,
                                        validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_POSTCODE],
                                    },
                                    country: {
                                        value: 'United Kingdom',
                                        hasError: false,
                                        errorType: null,
                                        errorMessage: null,
                                        validations: [],
                                    },
                                },
                            };
                            const newDeliveryAddress =
                                validateFieldSet(customerValue.deliveryAddress);
                            const pageHasError = newDeliveryAddress.hasError;
                            if (!pageHasError) {
                                setCustomerDetails({ ...customerDetails, customerAddress: newDeliveryAddress.fields })
                                let data = {
                                    "UserID": localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                                    "CompanyName": "",
                                    "UserName": customerDetails.firstName.value.toLowerCase().trim(),
                                    "FirstName": customerDetails.firstName.value.trim(),
                                    "LastName": customerDetails.lastName.value.trim(),
                                    "Email": customerDetails.emailAddress.value.trim(),
                                    "Addresses": [
                                        {
                                            "AddressType": "Billing",
                                            "HouseNo": "",
                                            "AddressLine1": customerDetails.deliveryAddress.line1.value,
                                            "AddressLine2": customerDetails.deliveryAddress.line2.value,
                                            "City": customerDetails.deliveryAddress.city.value,
                                            "StateProvinceRegion": customerDetails.deliveryAddress.state.value,
                                            "PostZipCode": customerDetails.deliveryAddress.postcode.value,
                                            "Country": customerDetails.deliveryAddress.country.value,
                                            "Phone": customerDetails.mobileNo.value.replace("+44", ""),
                                            "Fax": "",
                                            "Email": "",
                                            "CreatedDate": "",
                                            "LastModifiedDate": "",
                                            "IsDefault": false,
                                            "IsActive": false,
                                            "TelephoneCode": "+44",
                                            "AddressLabel": ""
                                        },
                                        {
                                            "AddressType": "Delivery",
                                            "HouseNo": "",
                                            "AddressLine1": customerDetails.deliveryAddress.line1.value,
                                            "AddressLine2": customerDetails.deliveryAddress.line2.value,
                                            "City": customerDetails.deliveryAddress.city.value,
                                            "StateProvinceRegion": customerDetails.deliveryAddress.state.value,
                                            "PostZipCode": customerDetails.deliveryAddress.postcode.value,
                                            "Country": customerDetails.deliveryAddress.country.value,
                                            "Phone": customerDetails.mobileNo.value.replace("+44", ""),
                                            "Fax": "",
                                            "Email": "",
                                            "CreatedDate": "",
                                            "LastModifiedDate": "",
                                            "IsDefault": false,
                                            "IsActive": false,
                                            "TelephoneCode": "+44",
                                            "AddressLabel": ""
                                        }
                                    ],
                                }

                                hanldeConfirm(data)

                            } else {
                                setCustomerDetails({ ...customerDetails, deliveryAddress: newDeliveryAddress.fields })
                            }
                        }
                    }}>
                    {isValidating && <div className="loader-btn " />}Validate</div>}
                {enableSchdeulOrders && localStorage.getItem("schedule_order") && getScheduleContent()}

            </>
        )
    }
    const getBillingContent = () => {
        return (
            <>
                <div className="left-content-container-header">Billing Address</div>
                <div className="left-content-container-flex">
                    <CustomInput
                        required
                        label={"Address Line 1"}
                        icon={"address"}
                        placeholder="Enter your address"
                        value={customerDetails?.customerAddress?.line1.value}
                        error={customerDetails?.customerAddress?.line1.hasError}
                        onChange={(e) => onFormDataChanged('customerAddress.line1', e.target.value)}
                        errorText={customerDetails?.customerAddress?.line1?.errorMessage}
                    />
                    <CustomInput
                        label={"Address Line 2 (Optional)"}
                        placeholder="Apt, suite, or other (optional)"
                        value={customerDetails.customerAddress.line2.value}
                        error={customerDetails.customerAddress.line2.hasError}
                        onChange={(e) => onFormDataChanged('customerAddress.line2', e.target.value)}
                        errorText={customerDetails.customerAddress.line2.errorMessage}
                    />
                </div>
                <div className="left-content-container-flex">
                    <CustomInput
                        required
                        label={"City"}
                        placeholder="City"
                        value={customerDetails.customerAddress.city.value}
                        error={customerDetails.customerAddress.city.hasError}
                        onChange={(e) => onFormDataChanged('customerAddress.city', e.target.value)}
                        errorText={customerDetails.customerAddress.city.errorMessage}
                    />
                    <CustomInput
                        required
                        label={"Postal Code"}
                        placeholder="Postal Code"
                        value={customerDetails.customerAddress.postcode.value}
                        error={customerDetails.customerAddress.postcode.hasError}
                        onChange={(e) => onFormDataChanged('customerAddress.postcode', e.target.value)}
                        errorText={customerDetails.customerAddress.postcode.errorMessage}
                    />
                    <CustomInput
                        required
                        label={"State"}
                        placeholder="State"
                        value={customerDetails.customerAddress.state.value}
                        error={customerDetails.customerAddress.state.hasError}
                        onChange={(e) => onFormDataChanged('customerAddress.state', e.target.value)}
                        errorText={customerDetails.customerAddress.state.errorMessage}
                    />
                    <CustomInput
                        label={"Country"}
                        placeholder="Country"
                        value={customerDetails.customerAddress.country.value}
                        disable
                    />
                </div>
                {enableSchdeulOrders && localStorage.getItem("schedule_order") && getScheduleContent()}
            </>
        )
    }

    const getDineInContent = () => {
        return (
            <>
                <div className="selected-table-container">
                    <img alt="" className="company-image"
                        src={company?.StoreImage ? company?.StoreImage : "https://img.freepik.com/premium-vector/storefront-line-design-hand-drawn-shop-line-art-vector-illustration_898083-3142.jpg?semt=ais_hybrid&w=740"} />

                    <div className="selected-table-container-details">
                        <div className="table-cont-floor">
                            <div className="table-cont-floor-container">
                                <div className="table-cont-floor-container-title">Area</div>
                                <div className="table-cont-floor-container-number">{selectedFloor?.Name ?? "loading"}</div>
                            </div>
                            <div className="table-cont-floor-container">
                                <div className="table-cont-floor-container-title">Table Number</div>
                                <div className="table-cont-floor-container-number">{selectedTable?.TableName ?? "loading"}</div>
                            </div>
                        </div>
                        {selectedTable?.Covers && <div className="table-cont"><img alt="" src={covers} className="table-cont-image" />Capacity: {selectedTable?.Covers?.Maximum} People</div>}
                        <div className="table-cont"><img alt="" src={seatings} className="table-cont-image" />Type: Standard Seating</div>

                    </div>
                </div>
                <div className="dinein-secure-cont">
                    <div className="dinein-secure-cont-header-cont">
                        <img alt="" src={info} className="header-cont-icon" />
                        <div className="header-cont-title ">Dine In Information</div>
                    </div>
                    <div className="dinein-secure-cont-sub">
                        Your order will be prepared and served directly to your selected table. Our staff will assist you with any additional requirements during your dining experience.
                    </div>
                </div>
            </>
        )
    }
    const handlePayClick = () => {
        if (adyenRef.current) {
            adyenRef.current.submit();
        }
    };
    const getCashComponent = () => {

        return (
            <>
                <div className="cash-secure-cont">
                    <div className="cash-secure-cont-header-cont">
                        <img alt="" src={lock} className="header-cont-icon" />
                        <div className="header-cont-title ">Cash Payment Information</div>
                    </div>
                    <div className="cash-secure-cont-sub">
                        Please have the exact amount ready for our delivery driver. Our drivers carry limited change for security reasons.
                    </div>
                </div>
                {/* <div className="change-container-wrapper">
                    Do you need change?
                    <div className="change-container">
                        {amountTypes.map((type) => {
                            return (
                                <div>
                                    <CustomRadioButton
                                        label={type.label}
                                        value={String(type.needChange)}
                                        checked={needChange === type.needChange}
                                        onChange={(e) => {
                                            setNeedChange(e.target.value === 'true')
                                            setChangeAmount("")
                                        }}
                                    />
                                </div>
                            )
                        })}</div>
                    <CustomInput
                        label={"If you need change, from what amount?"}
                        placeholder="£ Enter amount (e.g £50)"
                        value={changeAmount}
                        onChange={(e) => setChangeAmount(e.target.value)}
                        type="number"
                        disable={!needChange}
                    />
                </div> */}
            </>
        )
    }
    return (
        <div className="HospitalityV2-OrderPage">
            {isPaymentLoading &&
                <div className="overlayer" ><div className="order-placing">Please wait your order in progress ...</div></div>
            }
            <MenuNavbarMini />
            <div className="HospitalityV2-OrderPage-inner">
                <div className="HospitalityV2-OrderPage-title">Checkout</div>
                <div className="HospitalityV2-OrderPage-sub">Complete your order by providing the required information below</div>
                <div className="HospitalityV2-OrderPage-cont">
                    <div className="HospitalityV2-OrderPage-cont-left">
                        <div className="left-content-container">
                            <div className="left-content-container-title">Account Options</div>
                            <div className="account-typ-opt-cont">
                                {localStorage.getItem('isLogged') !== 'true' ?
                                    <>
                                        <div className={`account-typ-opt ${isGuest ? "selected" : ""}`}>
                                            <img alt="" className="type-icon" src={profile} />
                                            <div className="account-typ-opt-header">Continue as Guest</div>
                                            <div className="account-typ-opt-sub">No account required</div>
                                        </div>
                                        <div className={`account-typ-opt ${!isGuest ? "selected" : ""}`}
                                            onClick={() => {
                                                setIsGuest(false)
                                                setIsModalVisible(true)
                                            }}>
                                            <img alt="" className="type-icon" src={lock} />
                                            <div className="account-typ-opt-header">Login to Account</div>
                                            <div className="account-typ-opt-sub">Access saved details</div>
                                        </div>
                                    </> :
                                    <>
                                        <div className={`account-typ-opt ${!isGuest ? "selected" : ""}`}
                                        >
                                            <img alt="" className="type-icon" src={profile} />
                                            <div className="account-typ-opt-header">{parsedUserDetails?.FirstName} {parsedUserDetails?.LastName}</div>
                                            <div className="account-typ-opt-sub">{parsedUserDetails?.Email}</div>
                                        </div>
                                        <div style={{ width: "100%" }} />
                                    </>
                                }
                            </div>
                        </div>
                        <div className="left-content-container">
                            <div className="left-content-container-title">Contact Information</div>
                            <div className="left-content-container-flex">
                                <CustomInput
                                    required
                                    label={"First Name"}
                                    icon={"user"}
                                    placeholder="Enter your first name"
                                    value={customerDetails?.firstName?.value}
                                    error={customerDetails?.firstName?.hasError}
                                    onChange={(e) => onFormDataChanged('firstName', e.target.value)}
                                    errorText={customerDetails?.firstName?.errorMessage}
                                    disable={localStorage.getItem('isLogged') === 'true'}
                                />
                                <CustomInput
                                    required
                                    label={"Last Name"}
                                    icon={"user"}
                                    placeholder="Enter your last name"
                                    value={customerDetails?.lastName?.value}
                                    onChange={(e) => onFormDataChanged('lastName', e.target.value)}
                                    errorText={customerDetails?.lastName?.errorMessage}
                                    error={customerDetails?.lastName?.hasError}
                                    disable={localStorage.getItem('isLogged') === 'true'}

                                />

                            </div>
                            <div className="left-content-container-flex">
                                <CustomInput
                                    required
                                    label={"Email Address"}
                                    icon={"email"}
                                    placeholder="Enter your email address"
                                    value={customerDetails?.emailAddress?.value}
                                    onChange={(e) => onFormDataChanged('emailAddress', e.target.value)}
                                    errorText={customerDetails?.emailAddress?.errorMessage}
                                    error={customerDetails?.emailAddress?.hasError}
                                    disable={localStorage.getItem('isLogged') === 'true'}


                                />
                                <CustomPhoneInput
                                    required
                                    label={"Phone Number"}
                                    placeholder="Enter your phone number"
                                    value={customerDetails?.mobileNo?.value}
                                    onChange={(e) => {
                                        if (e === undefined) {
                                            onFormDataChanged('mobileNo', "")
                                        } else {
                                            onFormDataChanged('mobileNo', e)
                                        }
                                    }}
                                    errorText={customerDetails?.mobileNo?.errorMessage}
                                    error={customerDetails?.mobileNo?.hasError}
                                // disable={localStorage.getItem('isLogged') === 'true'}

                                />

                            </div>
                        </div>     <div className="left-content-container">
                            <div className="left-content-container-title">Delivery Options</div>

                            <div className="multi-typ-opt-cont">
                                {defaultDetails?.orderTypes?.includes("delivery") && <div className={`multi-typ-opt ${selectedOrderType === "table" ? "disable" : isSameOrderType === "delivery" ? "selected" : ""}`}
                                    onClick={() => {
                                        if (selectedOrderType !== "table") {
                                            setIsSameOrderType("delivery")
                                        }
                                    }}>
                                    <img alt="" className="multi-typ-opt-icon" src={deliveryIc} />
                                    Delivery
                                </div>}
                                {defaultDetails?.orderTypes?.includes("collection") && <div className={`multi-typ-opt ${selectedOrderType === "table" ? "disable" : isSameOrderType === "collection" ? "selected" : ""}`}
                                    onClick={async () => {
                                        if (selectedOrderType !== "table") {

                                            if (isSameOrderType !== "collection") {
                                                if (localStorage.getItem("schedule_order")) {
                                                    setSchedModal(true)
                                                }
                                            }
                                            setIsSameOrderType("collection")
                                            dispatch(setSelectedOrderType("collection"))
                                            await updateOrderType("TAKE_AWAY")

                                        }
                                    }}
                                >
                                    <img alt="" className="multi-typ-opt-icon" src={collectionIC} />
                                    Collection
                                </div>}
                                {selectedOrderType === "table" && <div className={`multi-typ-opt ${isSameOrderType === "table" ? "selected" : ""}`}
                                    onClick={() => {
                                        setIsSameOrderType("table")
                                    }}>
                                    <img alt="" className="multi-typ-opt-icon" src={dineinIC} />
                                    Dine In
                                </div>}

                            </div>
                            {selectedOrderType === "table" ? getDineInContent() : isSameOrderType === "delivery" && defaultDetails?.orderTypes?.includes("delivery") ? getDeliveryContent() : getBillingContent()}


                        </div>     <div className="left-content-container">
                            <div className="left-content-container-title">Payment Method</div>
                            <div className="pay-typ-opt-cont">

                                {paymentTypes.includes("cash") &&
                                    <div className={`multi-typ-opt ${!isCardPayment ? "selected" : ""}`} onClick={() => { setIsCardPayment(false) }}>
                                        <img alt="" className="multi-typ-opt-icon" src={cash} />
                                        {selectedOrderType === "delivery" ? "Cash on Delivery" : selectedOrderType === "collection" ? "Cash on Collection" : "Cash"}
                                    </div>}
                                {paymentTypes.includes("card") && <div className={`multi-typ-opt ${isCardPayment ? "selected" : ""}`} onClick={() => { setIsCardPayment(true) }}>
                                    <img alt="" className="multi-typ-opt-icon" src={card} />
                                    Card Payment
                                </div>}
                            </div>
                            {isCardPayment && companyDetails.PaymentIntegration && companyDetails.PaymentIntegration.
                                IntegrationName === "Wittally" && !redirectResult &&
                                <>
                                    <HospitalityV2Payment
                                        ref={adyenRef}
                                        instruction={customerDetails.instruction.value || ""}
                                        customerDetails={
                                            getCustomerDetails()
                                        }
                                        selectedTable={selectedTable}
                                        setIsOrderLoading={setIsOrderLoading}
                                        setIsPaymentLoading={setIsPaymentLoading}
                                        setShowPaymentErrorModal={setShowPaymentErrorModal}
                                        scheduleOrder={scheduleOrder}
                                        emailAddress={customerDetails.emailAddress.value || ""}
                                        firstName={customerDetails.firstName.value || ""}
                                        lastName={customerDetails.lastName.value || ""}
                                        phoneNumber={customerDetails.mobileNo.value}

                                    />
                                    <div className="payment-secure-cont">
                                        <div className="payment-secure-cont-header-cont">
                                            <img alt="" src={lock} className="header-cont-icon" />
                                            <div className="header-cont-title ">Secure Payment</div>
                                        </div>
                                        <div className="payment-secure-cont-sub">
                                            Your payment information is encrypted and secure. We never store your full card details.
                                        </div>
                                    </div>
                                </>
                            }
                            {!isCardPayment && selectedOrderType === "delivery" &&
                                getCashComponent()}
                        </div>     <div className="left-content-container">
                            <div className="left-content-container-title">Additional Information</div>
                            <div className="left-content-container-flex">
                                <CustomTextArea
                                    label={"Order Notes (Optional)"}
                                    placeholder="Add any special requests or notes about your order"
                                    value={customerDetails?.instruction?.value}
                                    error={customerDetails?.instruction?.hasError}
                                    onChange={(e) => {
                                        sessionStorage.setItem("store_instruction", e.target.value)
                                        onFormDataChanged('instruction', e.target.value)

                                    }}
                                    errorText={customerDetails?.instruction?.errorMessage}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="HospitalityV2-OrderPage-cont-right">
                        <div className="order-summary-cont-header" onClick={() => {
                            setIsCollapsed(!isCollapsed)
                        }}>
                            <div className="order-summary-cont-header-title">Order Summary</div>
                            <img alt="" className={`arrow-icon ${!isCollapsed ? "closed" : ""}`} src={arrow} />
                        </div>
                        {isCollapsed && <div className="order-summary-cart">
                            <div className="order-summary-cart-title">{restaurantDataState.orderCartData.Items.length === 1 ? "Item" : "Items"}({restaurantDataState.orderCartData.Items.length})</div>
                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.map((item, index) => {
                                const _hasAddons = item.SelectedModifierGroups.length > 0;
                                return (
                                    <div className="order-summary-cart-item-cont" key={index}>
                                        <div className="order-summary-cart-item">
                                            <div className="order-summary-cart-item-left">
                                                <img
                                                    src={item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER}
                                                    style={{ objectFit: item.PictureURL === "" ? "fill" : "" }}
                                                    className="cart-item-image" />

                                                <div className='item-details-container-left'>
                                                    <div className="item-details-container-con">
                                                        <div className="item-details-cont">
                                                            <div className='item-cart-title truncate-text'>{item?.Title?.toLowerCase()}</div>
                                                            <div className="qty-container">
                                                                Qty: {item.Quantity.Amount}
                                                            </div>
                                                        </div>
                                                        <div className='item-cart-price'> {getPrice(item.PriceInfo.TotalPrice)}</div>

                                                    </div>
                                                    <div className="modifiers-text">
                                                        {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                            <span key={index}> {renderModifierGroups(selectedGroup, item)} </span>
                                                        ))}
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                )
                            })}
                        </div>}
                        <div className="order-summary-cont-payment" >
                            {/* <div className="promo-cont">
                                <input className="promo-input"
                                    placeholder="Enter promo code"
                                    value={promo}
                                    onChange={(e) => setPromo(e.target.value)}
                                />
                                <div className="promo-btn">Apply</div>
                            </div> */}
                            <div className="price-list-inner">
                                <div className="price-list-inner-left">Sub total</div>
                                <div className="price-list-inner-right">     {restaurantDataState.orderDetails.Payment.
                                    PaymentDetail.ItemCharges.Gross.Formatted}</div>

                            </div>
                            {restaurantDataState?.orderDetails?.Payment.
                                PaymentDetail?.Fee?.Details?.map((fee, key) => {
                                    return (
                                        <div className="price-list-inner" key={key}>
                                            <div className="price-list-inner-left">{fee.Description}</div>
                                            <div className="price-list-inner-right">
                                                {fee.Amount.DisplayAmount}
                                            </div>
                                        </div>
                                    )
                                })}
                            {restaurantDataState?.orderDetails?.Payment?.
                                PaymentDetail?.Promotions?.Detail?.length > 0 && restaurantDataState?.orderDetails?.Payment?.
                                    PaymentDetail?.Promotions?.Detail?.map((fee, key) => {
                                        return (
                                            <div className="price-list-inner" key={key}>
                                                <div className="price-list-inner-left">Promotion
                                                    <span className="price-list-inner-left-dis">
                                                        {fee?.DiscountPercentage}% off
                                                    </span>
                                                </div>
                                                <div className="price-list-inner-right-dis">
                                                    - {currencyFormat(fee?.SavingsAmount / 100)}
                                                </div>
                                            </div>
                                        )
                                    })}
                            <div className="price-list-inner-total" >
                                <div className="total-value-text ">Total Price</div>
                                <div className="total-value-text ">
                                    {restaurantDataState.orderDetails.Payment.
                                        PaymentDetail.OrderTotal.Gross.Formatted}
                                </div>
                            </div>
                        </div>
                        <div className="order-summary-cont-bottom">
                            <div className="order-terms" >
                                <CustomCheckbox checked={promoChecked} onChange={() => {
                                    setWhatsappChecked(false)
                                    setEmailChecked(false)
                                    setSmsChecked(false)
                                    setShowPopup(!promoChecked)
                                    setPromoChecked(!promoChecked)
                                }} />
                                <div className="order-text">
                                    I agree to receive promotions and special offers.
                                </div>
                            </div>
                            <div className="order-terms" style={{ marginTop: 10 }}>
                                <CustomCheckbox checked={rulesChecked} onChange={() => { setRulesChecked(!rulesChecked) }} />
                                <div className="order-text">
                                    I agree to the <span>Terms and Conditions</span> and <span>Privacy Policy</span>
                                </div>
                            </div>

                            <div className={`order-chackout-btn ${!rulesChecked ? "disabled" : ""}`}
                                onClick={() => {
                                    validateAllFormData().then(async (error) => {
                                        if (!error) {
                                            if (selectedOrderType === isSameOrderType) {
                                                if (paymentTypes.length !== 0) {
                                                    setIsOrderLoading(true)
                                                    setIsPaymentLoading(true)
                                                    let locID = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                                                    let _cloudLocations = [{
                                                        CloudLocationID: locID,
                                                        CloudLocationName: "",
                                                    }]
                                                    const _orderTypeData = await getOrderTypeData(_cloudLocations);
                                                    const defaultLocOrder = _orderTypeData.find(array =>
                                                        array.some(item => item.CloudLocationID === locID)
                                                    )
                                                    const _orderTypeNames = defaultLocOrder ? defaultLocOrder.map(_item => _item.OrderTypeName) : [...new Set(_orderTypeData.flat().map(_item => _item.OrderTypeName))];
                                                    const _defaultOrderType = defaultLocOrder ? defaultLocOrder.find(item => item.IsDefault) : _orderTypeData.flat().find(item => item.IsDefault);
                                                    let storedData = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA);
                                                    await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA, {
                                                        ...storedData,
                                                        defaultOrderType: _defaultOrderType.OrderTypeName,
                                                        orderTypes: _orderTypeNames,
                                                        selectedOrderType: selectedOrderType
                                                    });
                                                    await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA, {
                                                        ...storedData,
                                                        defaultOrderType: _defaultOrderType.OrderTypeName,
                                                        orderTypes: _orderTypeNames,
                                                        selectedOrderType: selectedOrderType

                                                    });
                                                    await handleUpdateOrder()
                                                    if (_orderTypeNames.includes(selectedOrderType)) {
                                                        if (!isCardPayment) {
                                                            const schedTime = JSON.parse(scheduleOrder)
                                                            const table = localStorage.getItem("selected_table") ? JSON.parse(localStorage.getItem("selected_table")) : {}
                                                            const customer = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}
                                                            if (customer) {
                                                                let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customer }]
                                                                let updatedData = {
                                                                    ...restaurantDataState.orderDetails, Customers: customerData, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: table, OrderType
                                                                        : "MENU",
                                                                    StoreInstructions: sessionStorage.getItem("store_instruction") ?? "",
                                                                    ScheduledOrderTargetDeliveryTimeRange: schedTime.StartTime ? { StartTime: schedTime?.StartTime, EndTime: schedTime?.EndTime } : {}
                                                                }
                                                                if (schedTime?.StartTime) {
                                                                    const startTime = schedTime?.StartTime?.replace('Z', '')
                                                                    const hasPassed = moment().isAfter(moment(startTime));
                                                                    if (!hasPassed) {
                                                                        dispatch(setOrderData(updatedData))
                                                                        if (!isOrderLoading) {
                                                                            placeCartOrder("CASH_ON_DELIVERY")
                                                                        }
                                                                    }
                                                                    else {
                                                                        setIsOrderLoading(false)
                                                                        setIsPaymentLoading(false)
                                                                        setIsScheduleTimeError(true)

                                                                    }
                                                                } else {
                                                                    dispatch(setOrderData(updatedData))
                                                                    if (!isOrderLoading) {
                                                                        placeCartOrder("CASH_ON_DELIVERY")
                                                                    }
                                                                }
                                                            }
                                                        } else {
                                                            const schedTime = JSON.parse(scheduleOrder)
                                                            if (schedTime?.StartTime) {
                                                                const startTime = schedTime?.StartTime?.replace('Z', '')
                                                                const hasPassed = moment().isAfter(moment(startTime));
                                                                if (!hasPassed) {
                                                                    if (!isOrderLoading) {
                                                                        handlePayClick()
                                                                    }
                                                                }
                                                                else {
                                                                    setIsOrderLoading(false)
                                                                    setIsPaymentLoading(false)
                                                                    setIsScheduleTimeError(true)

                                                                }
                                                            } else {
                                                                if (!isOrderLoading) {
                                                                    handlePayClick()
                                                                }
                                                            }
                                                        }
                                                    } else {
                                                        setIsOrderLoading(false)
                                                        setIsPaymentLoading(false)
                                                        setIsStoreOrderBlocked(true)
                                                    }
                                                }
                                            } else {
                                                setDeliveryNotverfied(true)
                                            }
                                        } else {

                                            setShowErrorModal(true)
                                        }
                                    })
                                }}

                            >
                                Place Order -  {restaurantDataState.orderDetails.Payment.
                                    PaymentDetail.OrderTotal.Gross.Formatted}
                            </div>
                            <div className="order-secure-cont">
                                <div className="order-secure-inner">
                                    <img alt="" src={lock} className="lock" />Secure Checkout</div>
                                <div className="order-secure-inner">
                                    <img alt="" src={secu} className="secu" />SecureSSL Encrypted</div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <MenuFooter />
            <Modal visibility={showErrorModal} type="failed" headerText="Required fields are missing." subText={getErrorMessages()} onPopupClose={() => {
                setShowErrorModal(false)
            }} />
            <Modal visibility={showPaymentErrorModal} type="failed" headerText="Required fields are missing." subText={'Please fill in all the required payment details to continue.'} onPopupClose={() => {
                setShowPaymentErrorModal(false)
                setIsPaymentLoading(false)
                setIsOrderLoading(false)
            }} />
            <Modal visibility={deliverySuccess} type="success" headerText="Great news! We deliver to your location" subText="Enjoy fresh and fast delivery straight to your doorstep. Place your order now!" onPopupClose={() => {
                setIsSameOrderType("delivery")
                setDeliverySuccess(false)
                if (localStorage.getItem("schedule_order")) {
                    setSchedModal(true)
                }
            }} />
            <Modal visibility={checkoutFailed !== ""} type="failed" headerText="Sorry!" subText={checkoutFailed + " Would you like to go to the menu and add the required items?"} onPopupClose={() => {
                dispatch(setSelectedOrderType("delivery"))
                setIsSameOrderType("delivery")
                setCheckoutFailed("")
                history.push("/")
                localStorage.setItem("failedDeliveryOpt", "true")
            }} />
            <Modal visibility={schedModal} type="failed" headerText=" Scheduled Time May Be Affected!" subText={`Sorry, Please review your scheduled order time. It may no longer be valid with the new ordering type. Adjust the schedule if necessary.`} onPopupClose={() => {
                setSchedModal(false)
                setSelectedDate(getNext7Days()[0])
                setSelectedTime(getTodayIntervals()[0])
                let scheduletime = {
                    StartTime: `${getNext7Days()[0]}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                    EndTime: `${getNext7Days()[0]}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
                }
                setScheduleOrder(JSON.stringify(scheduletime))
                localStorage.setItem("schedule_order", JSON.stringify(scheduletime))
            }} />
            <Modal visibility={deliveryFailed} type="failed" headerText="Uh-oh! Looks like we can’t reach you" subText={`Sorry, we don’t currently deliver to your area. Stay tuned for updates!`} onPopupClose={() => {
                setDeliveryFailed(false)
            }} />
            <Modal visibility={deliveryNotverfied} type="failed" headerText="Please verify your delivery address before proceeding to checkout."
                subText={`To proceed with your order, please check if your address is within our delivery zone.`} onPopupClose={() => {
                    setDeliveryNotverfied(false)
                }} />
            <HospitalityLoginModal
                visibility={isModalVisible}
                onPopupClose={() => {
                    if (localStorage.getItem('isLogged') !== 'true') {
                        setIsGuest(true)
                    } else {
                        setIsGuest(false)
                    }
                    setIsModalVisible(false)
                }}
                setCustomerDetails={setCustomerDetails}
                setIsCardPayment={setIsCardPayment}
                useDeliveryForBilling={useDeliveryForBilling}
                fromCheckout={true}
                setIsError={setIsError}

            />
            <Modal visibility={isError} type="failed" headerText="Invalid Login" subText="Invalid username or password"
                onPopupClose={() => {
                    setIsError(false)
                }}
            />
            <Modal visibility={isStoreOrderBlocked} type="failed" headerText={selectedOrderType + " Unavailable"} subText={`Store is not accepting ${selectedOrderType} orders at the moment. Would you like to switch your order type to ${selectedOrderType === "collection" ? "delivery" : "collection"} instead?`}
                onPopupClose={() => {
                    let type = selectedOrderType === "collection" ? "delivery" : "collection"
                    if (type === "collection") {
                        setIsSameOrderType("collection")
                        dispatch(setSelectedOrderType("collection"))
                        updateOrderType("TAKE_AWAY")

                    } else {
                        setAddDeliveryLoc(true)
                    }
                    setIsStoreOrderBlocked(false)
                }}
            />
            <LocationFinder visibility={addDeliveryLoc}
                setAddDeliveryLoc={setAddDeliveryLoc}
                onPopupClose={() => {
                    setAddDeliveryLoc(false)
                }}
                setDeliverySuccess={setDeliverySuccess}
                setDeliveryFailed={setDeliveryFailed}
                onHandle={(response, customerData) => {
                    let customerValue = {
                        deliveryAddress: {
                            line1: {
                                value: customerData.deliveryAddress.line1.value || "",
                                hasError: false,
                                errorType: null,
                                errorMessage: null,
                                validations: [],
                            },
                            line2: {
                                value: customerData.deliveryAddress.line2.value || "",
                                hasError: false,
                                errorType: null,
                                errorMessage: null,
                                validations: [],
                            },
                            state: {
                                value: customerData.deliveryAddress.state.value || "",
                                hasError: false,
                                errorType: null,
                                errorMessage: null,
                                validations: [],
                            },
                            city: {
                                value: customerData.deliveryAddress.city.value || "",
                                hasError: false,
                                errorType: null,
                                errorMessage: null,
                                validations: [],
                            },
                            postcode: {
                                value: customerData.deliveryAddress.postcode.value || "",
                                hasError: false,
                                errorType: null,
                                errorMessage: null,
                                validations: [],
                            },
                            country: {
                                value: 'United Kingdom',
                                hasError: false,
                                errorType: null,
                                errorMessage: null,
                                validations: [],
                            },
                        },
                    };
                    const newDeliveryAddress =
                        validateFieldSet(customerValue.deliveryAddress);
                    setCustomerDetails({ ...customerDetails, customerAddress: newDeliveryAddress.fields })
                    let data = {
                        "UserID": localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                        "CompanyName": "",
                        "UserName": customerDetails.firstName.value.toLowerCase().trim(),
                        "FirstName": customerDetails.firstName.value.trim(),
                        "LastName": customerDetails.lastName.value.trim(),
                        "Email": customerDetails.emailAddress.value.trim(),
                        "Addresses": [
                            {
                                "AddressType": "Billing",
                                "HouseNo": "",
                                "AddressLine1": customerData.deliveryAddress.line1.value,
                                "AddressLine2": customerData.deliveryAddress.line2.value,
                                "City": customerData.deliveryAddress.city.value,
                                "StateProvinceRegion": customerData.deliveryAddress.state.value,
                                "PostZipCode": customerData.deliveryAddress.postcode.value,
                                "Country": customerData.deliveryAddress.country.value,
                                "Phone": "",
                                "Fax": "",
                                "Email": "",
                                "CreatedDate": "",
                                "LastModifiedDate": "",
                                "IsDefault": false,
                                "IsActive": false,
                                "TelephoneCode": "+44",
                                "AddressLabel": ""
                            },
                            {
                                "AddressType": "Delivery",
                                "HouseNo": "",
                                "AddressLine1": customerData.deliveryAddress.line1.value,
                                "AddressLine2": customerData.deliveryAddress.line2.value,
                                "City": customerData.deliveryAddress.city.value,
                                "StateProvinceRegion": customerData.deliveryAddress.state.value,
                                "PostZipCode": customerData.deliveryAddress.postcode.value,
                                "Country": customerData.deliveryAddress.country.value,
                                "Phone": "",
                                "Fax": "",
                                "Email": "",
                                "CreatedDate": "",
                                "LastModifiedDate": "",
                                "IsDefault": false,
                                "IsActive": false,
                                "TelephoneCode": "+44",
                                "AddressLabel": ""
                            }
                        ],
                        "Email": "",
                    }
                    updateOrderType("DELIVERY_BY_REWARDCONSUMER").then((resolveData) => {
                        if (resolveData) {
                            let pricedata = {
                                "CloudLocationID": storeOrderLocalData?.cloudLocationID,
                                "OrderID": orderID,
                                "ReferenceNo": response
                            }
                            predictPrice(pricedata).then((res) => {
                                localStorage.setItem("DELIVERY_DATA", JSON.stringify(data))
                                setIsValidating(false)
                                setAddDeliveryLoc(false)
                                localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                dispatch(setSelectedOrderType("delivery"))
                                setIsSameOrderType("delivery")
                                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID, response)
                                let dataRes =
                                {
                                    Details: res.Details,
                                    Total: getTotal(res.Total, resolveData)
                                }

                                dispatch(setOrderDataPayment(dataRes))
                                setIsValidating(false)
                                setDeliveryFailed(false)
                                setDeliverySuccess(true)
                            }).catch((error) => {
                                console.log(error)
                                if (error.response.status === 404) {
                                    localStorage.setItem("fullUserDetails", JSON.stringify(data))
                                    dispatch(setSelectedOrderType("delivery"))
                                    setIsSameOrderType("delivery")
                                    localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID, response)
                                    setCheckoutFailed(error.response.data.Result)
                                    setIsValidating(false)
                                    setAddDeliveryLoc(false)
                                }
                            })
                        }
                    })
                }}
                isLoading={isValidating}
                from="ORDER"
            />
            <Modal visibility={isScheduleTimeError} type="failed" headerText="Scheduled Time Has Passed" subText="Please update the scheduled time to proceed with your order."
                onPopupClose={() => {
                    setIsScheduleTimeError(false)
                    setIsStoreClosed(true)
                }}
            />
            <ScheduleOrderModal visibility={isStoreClosed}
                onPopupClose={() => {
                    setIsStoreClosed(false)
                }}
                setOrderSchedule={setScheduleOrder}
                setSelectedOrderTime={setSelectedTime}
                showChancel={false}
                setSelectedOrderDate={setSelectedDate}
            />
            <ModalOpt
                visibility={showPopup}
                onPopupClose={() => {
                    setShowPopup(false)
                }}
                emailChecked={emailChecked}
                setEmailChecked={setEmailChecked}
                setSMSChecked={setSmsChecked}
                smsChecked={smsChecked}
                whatsappChecked={whatsappChecked}
                setWhatsappChecked={setWhatsappChecked} />
        </div >

    )
}
export default HospitalityV2OrderPage